import React from "react";
import { FaExclamation } from "react-icons/fa";
import "./crowdedStepGuideModal.css";
import {IoCloseOutline} from "react-icons/io5";
import CrowdedStepGuideContent from "./CrowdedStepGuideContent";

interface Props {
  closeCrowdedStepGuideModal: () => void;
}
interface State {}

export default class CrowdedStepGuideModal extends React.Component<Props, State> {
  render() {
    return (
      <div className={"crowded-step-guide-modal"}>
        <div className={"row"} style={{padding: "10px 0", alignItems: "flex-end", justifyContent: "space-between"}}>
          <div className={"row"}>
            <div className={"exclamation"} style={{marginRight: 5}}>
              <FaExclamation size={12}/>
            </div>
            <span style={{color: "#FFFFFF", fontWeight: "bold", fontSize: 18}}>인구 혼잡도 단계 기준</span>
          </div>

          <IoCloseOutline color={"#FFFFFF"} size={30} className={"cursor"} onClick={this.props.closeCrowdedStepGuideModal}/>
        </div>

        <CrowdedStepGuideContent />
        <div style={{fontSize: 11, color: "#8088A0", textAlign: "right", marginTop: 8}}>※ 혼잡도는 유동인구 계측 센서로 부터 수집되는 데이터를 분석하여 가공한 것으로, 실제 현장과는 차이가 있을 수 있습니다.</div>
      </div>
    );
  }
}
